<template>
  <div>
    <div class="box info-box">
        <div class="box-header with-border">
            <h3 class="box-title">Recent Members</h3>
        </div>
        <!-- /.box-header -->
        <div class="box-body">
          <table class="table table-sm table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Cust Name</th>
                <th class="hidden-xs">Cust Code</th>
                <th>Mobile</th>
                <th class="hidden-xs">Address</th>
                <!-- <th v-if="$gate.isAdmin()">Status</th>
                <th>Image</th>
                <th v-if="$gate.isAdmin()">Modify</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td class="hidden-xs">{{ index + 1 }}</td>
                <td v-if="row.user">{{ row.user.name }}</td>
                <td v-if="row.user" class="hidden-xs">{{ row.user.code }}</td>
                <td v-if="row.user">{{ row.user.mobile }}</td>
                <td class="hidden-xs" v-if="row.user">{{ row.address }}</td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- <div class="box-body">
            <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed small"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'Code'" >
                    <span style="font-size: 13px; font-weight: bold; color:#3c8dbc;">{{props.row.user.code}}</span>
                  </span>
                  
                  <span v-if="props.column.field == 'Email'" >
                    <span style="font-size: 12px;">{{props.row.user.email}}</span>
                  </span>

                  <span v-if="props.column.field == 'Father'" >
                    <span style="font-size: 12px;">{{props.row.fatherName}}</span>
                  </span>
                  <span v-if="props.column.field == 'SpouseName'" >
                    <span style="font-size: 13px;">{{props.row.spouseName}}</span>
                  </span>

                  <span v-if="props.column.field == 'Phone'" >
                    <span style="font-size: 13px;"><i class="fa fa-check-circle-o text-success" v-show="props.row.user.mobileVerify == 'true'"></i>{{props.row.user.mobile}}</span>
                  </span>
                  <span v-if="props.column.field == 'Status'" >
                    <p v-if="props.row.status == 'pending'" class="text-warning bg-warning text-center">{{props.row.status}}</p>
                    <p v-if="props.row.status == 'verified'" class="text-success bg-success text-center">{{props.row.status}}</p>
                    <p v-if="props.row.status == 'reject'" class="text-danger bg-danger text-center">{{props.row.status}}</p>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
            </vue-good-table>
        </div> -->
        <!-- /.box-body -->
        <!-- <div class="box-footer clearfix">
            <a href="javascript:void(0)" class="btn btn-sm btn-default btn-flat pull-right">View All Members</a>
        </div> -->
        <!-- /.box-footer -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'my-component',
  computed: {
    ...mapState([
      'profile',
      'user'
    ])
  },
  data () {
    return {
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    loadData () {
      var c = JSON.parse(localStorage.user)
      var userWise = ''
      if (c.role.name === 'Admin') {
        userWise = ''
      } else if (c.role.name === 'Manager') {
        userWise = `&branch_id=${c.agent_profile.branch_id}`
      } else {
        userWise = `&agent_id=${c.id}&branch_id=${c.agent_profile.branch_id}`
      }
      this.$axios.get('member?per_page=5' + userWise, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        this.rows = data.data
        // _.forEach(this.rows, function (item, key) {
        //   this.rows[key].name = item.user.name + ' (' + item.user.code + ')'
        // }.bind(this))
      })
      .catch(function (error) { console.log(error) })
    }
  },
  created () {
    this.loadData()
  }
}
</script>
<style scoped>
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// recentmember.vue?f521c5ea